import { SectionSystemCode } from '../../../../common/types';
import { TCustomRowsColum } from '../../../../components/controls/CustomRowsComboSelect';
import { TPortalCustomization } from '../../utils';

export const transportationServicesColumns: TCustomRowsColum[] = [
    { label: 'Transport', key: 'label', span: 4 },
    { label: 'Description', key: 'description', span: 8, withTooltip: 'description' },
];

export enum TripType {
    MultipleStops = 'M',
    RoundTrip = 'R',
  }
  
  export enum AddressTypes {
    Home = 'Home',
    Discharge = 'Discharge',
    Hospital = 'Hospital',
  }

export const appointmentToDestinationMap = new Map<string, string>([
    ['Doctor', 'Doctor'],
    ['IME', 'IME - Medical'],
    ['PhysicalTherapy', 'Physical Therapy'],
    ['Imaging', 'Diagnostics Facility'],
    ['Surgery', 'Hospital'],
    ['Pharmacy', 'Pharmacy'],
    ['Legal', 'Legal Appointment'],
    ['Lab', 'Lab'],
    ['Work', 'Work'],
    ['Discharge', 'Home'],
]);

export const preselectedProductsMap = new Map<TPortalCustomization, SectionSystemCode>([
  ['DX', 'DiagnosticServices'],
  ['DME', 'DurableMedicalEquipment'],
  ['HH', 'HomeHealthCare'],
  ['PHYM', 'PhysicalMedicine']
]);

export const IME_DEFAULT_VENDOR_NOTES = `Appointment Duration:

Please ensure the interpreter is on time and is wearing a mask for the exam.
This appointment is extremely important and is a Medical Evaluation.
It is critical that the service being provided is executed successfully.
This is a Medical Evaluation.
Must complete all confirmations via Vendor Web.
Interpreters must bring photo ID and Certification Credentials to the Exam.
Must be 15 minutes early to assist with paperwork.
Must complete full appointment. (No early departures).
Must provide great customer service.
Must call us for same day issue:
• Went to assignment but there is another interpreter there.
• Facility/claimant told me service is no longer needed or assignment is cancelled.
• Facility told me they will not proceed with appoint because I’m not certified (this is for exotic language only).
• Facility told me the assignment is going to last longer than the original time.
PLEASE NOTE: In case of same day issues and/or concern; Interpreter must contact (866) 966-3911 immediately for same day issue instruction.

DO NOT LEAVE the facility without granted authorization from One Call.
`;

export const VENDOR_NOTES_TOOLTIP = 'These notes will be sent directly to the provider. Use this field for anything the provider should know.';